/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfNotesTemplate } from '../../models/data-page-of-notes-template';

export interface NotesTemplateFindNotesByCategory$Params {
  categoryId: string | null;
  pageSize?: number;
  pageNumber?: number;
}

export function notesTemplateFindNotesByCategory(http: HttpClient, rootUrl: string, params: NotesTemplateFindNotesByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfNotesTemplate>> {
  const rb = new RequestBuilder(rootUrl, notesTemplateFindNotesByCategory.PATH, 'get');
  if (params) {
    rb.path('categoryId', params.categoryId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfNotesTemplate>;
    })
  );
}

notesTemplateFindNotesByCategory.PATH = '/api/NotesTemplate/category/{CategoryId}';
